import Cookies from "js-cookie";
import { useNavigate } from "react-router";

import { CreateUser as CreateUserGS } from "../../services/users";
import "./create-user.css";
import { useAlerts } from "../../contexts/AlertContext";

export default function CreateUser() {
    const navigate = useNavigate();
    const {addError} = useAlerts();
                    
    // useEffect(() => {
    //     new GetGroup().request({ authToken: Cookies.get("auth_code") || "" }).then(res => {
    //         setGroups(res.map(g => g.name));
    //     }).catch(err => {
    //         console.error("Error fetching groups:", err);
    //         alert("Failed to fetch groups. Please try again."); // TODO: better error handling
    //     });
    // }, []);

    const submit = async () => {
        const params = new URLSearchParams(window.location.search);
        const req = {
            name: (document.getElementById("create-user-name") as HTMLInputElement).value,
            defaultGroups: [] // TODO: custom link with query params that will define this (passed from login)
        };

        try {
            await (new CreateUserGS()).request(req, { authToken: Cookies.get("auth_code") || "" });
        } catch (err) {
            console.error("Error creating user:", err);
            addError(err as Error, "Error creating user");
            return;
        }

        navigate({
            pathname: "/login",
            search: `?${params.toString()}`
        })
    };

    return <div id="create-user-wrapper" className="container">
        <h1 id="create-user-header">Create User</h1>
        <input type="text" placeholder="Name" id="create-user-name" />
        <button id="create-user-submit" className="button" onClick={submit}>Create User</button>
    </div>;
}
